import {
    Dispatch,
    SetStateAction,
    KeyboardEvent,
    useRef,
    useState,
    useEffect,
    memo
} from 'react';
import theme from '@styles/theme';

import useEnter from '@hooks/useEnter';

import { FlexBox } from '@components/styled/StyledComponents';
import StyledModal from '@components/styled/StyledModal';
import StyledInput from '@components/styled/StyledInput';
import StyledButton from '@components/styled/StyledButton';

type SearchModalProps = {
    searchModal: boolean;
    setSearchModal: Dispatch<SetStateAction<boolean>>;
    setSearchTerm: Dispatch<SetStateAction<string>>;
};

const SearchModal = ({
    searchModal,
    setSearchModal,
    setSearchTerm
}: SearchModalProps) => {
    const onEnter = useEnter();
    const inputRef = useRef<HTMLInputElement>(null);
    const [input, setInput] = useState('');

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handleClose = () => {
        setSearchModal(false);
    };

    const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        onEnter(e, onSubmit);
    };

    const onSubmit = () => {
        setSearchTerm(input);
        handleClose();
    };

    return (
        <StyledModal
            title="검색하기"
            isOpen={searchModal}
            closeBtnHandler={handleClose}
            marginBottom={32}
        >
            <StyledInput
                ref={inputRef}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={onKeyDown}
                placeholder="검색어를 입력해주세요."
            />
            <FlexBox $justifyContent="flex-end" $gap={8} $margin="32px 0 0">
                <StyledButton
                    title="취소"
                    width={140}
                    fontColor={`${theme.colors.blackColor}`}
                    bgColor={`${theme.colors.whiteColor}`}
                    border={`${theme.colors.lightGrayBorder} 1px solid`}
                    onClick={handleClose}
                />
                <StyledButton
                    title="검색"
                    onClick={onSubmit}
                    width={140}
                    bgColor={theme.colors.pointGreen}
                />
            </FlexBox>
        </StyledModal>
    );
};

export default memo(SearchModal);
